import React, { useCallback, useContext } from 'react';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

interface Props {
  component: MBAPI.WorkflowTemplate_components_AuditCheckboxComponent;
  checked: boolean;
  onChange(newValue: boolean): void;
  isReadOnly?: boolean;
}

export function WorkflowAuditCheckbox({ checked, component, onChange, isReadOnly }: Props) {
  const colors = useContext(ColorThemeContext);

  const handleChange = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <>
      <View row marginBottom={2}>
        <MBTouchableOpacity onPress={handleChange} disabled={isReadOnly}>
          {checked ? (
            <MBIconV2 name="check-filled" color={colors.accent} />
          ) : (
            <MBIconV2 name="check-task" color={colors.input.borderInactive} />
          )}
        </MBTouchableOpacity>
        <View paddingTop={1.25} flex paddingLeft={1}>
          <MBTextBody1 flex>{component?.label}</MBTextBody1>
        </View>
      </View>
    </>
  );
}
